// @todo Забирать с бекенда из методов доставки
export const NOVA_POSHTA_PRICE_LIMIT = 499
export const UKR_POSHTA_PRICE_LIMIT = 5000000
export const COURIER_PRICE_LIMIT = 5000000
